import { Controller } from "@hotwired/stimulus"
import TurbolinksAdapter from "vue-turbolinks"
import ResizeTextarea from 'resize-textarea-vue3'
import { createApp } from "vue"

import App from "../quiz/backend/App.vue"

// Connects to data-controller="backend-quiz-loader"
export default class extends Controller {
  connect() {
    // console.log('************** backend-quiz-loader', this.element.id, this.element, this.element.dataset, params)
    const params = this.element.dataset
    createApp(App, {...params})
       .use(ResizeTextarea)
       .use(TurbolinksAdapter)
       .mount(`#${this.element.id}`)
  }
}
